import Select from 'react-select'
import './NumberRangeInput.scoped.scss'

const OPERATOR_OPTIONS = [
  { value: '=', label: '= (equal to)' },
  { value: '>', label: '> (more than)' },
  { value: '<', label: '< (less than)' },
  { value: '>=', label: '>= (at least)' },
  { value: '<=', label: '<= (at most)' },
  { value: 'between', label: 'between (inclusive)' },
]

export default function NumberRangeInput({ value, onChange }) {
  const safeValue = value && typeof value === 'object' ? value : { operator: '>=', value: '' }
  const operator = safeValue.operator || '>='

  function handleOperatorChange(option) {
    if (option.value === 'between') {
      onChange({ operator: 'between', min: '', max: '' })
    } else {
      onChange({ operator: option.value, value: safeValue.value || '' })
    }
  }

  function update(key, val) {
    onChange({ ...safeValue, [key]: val })
  }

  return (
    <div className="number-range-input">
      <div className="number-range-operator">
        <Select
          options={OPERATOR_OPTIONS}
          value={_.find(OPERATOR_OPTIONS, { value: operator })}
          onChange={handleOperatorChange}
        />
      </div>
      {operator === 'between' ? (
        <>
          <input
            type="number"
            style={{ width: '100px' }}
            value={safeValue.min || ''}
            onChange={(e) => update('min', e.target.value)}
          />
          <span className="number-range-label">and</span>
          <input
            type="number"
            style={{ width: '100px' }}
            value={safeValue.max || ''}
            onChange={(e) => update('max', e.target.value)}
          />
        </>
      ) : (
        <input
          type="number"
          style={{ width: '100px' }}
          value={safeValue.value || ''}
          onChange={(e) => update('value', e.target.value)}
        />
      )}
    </div>
  )
}
